(() => {
  const root = document.querySelector('[data-mayhem-pdp-summary]');
  if (!root) return;
  const primaryActions = root.querySelector('.mayhem-pdp-summary__actions');
  const setupActions = root.querySelector('.mayhem-setup-actions');
  const arrangeActions = () => {
    if (!primaryActions || !setupActions) return;
    (root.querySelector('[data-config-actions-help]') || setupActions).before(primaryActions);
  };
  arrangeActions();
  const groups = [...root.querySelectorAll('.mayhem-finish-swatches--product, .mayhem-pdp-summary__chips, .mayhem-pdp-summary__actions, .mayhem-setup-actions')];
  const update = group => {
    const count = [...group.children].filter(child => !child.hidden).length;
    const css = getComputedStyle(group);
    const minimum = Number(css.getPropertyValue('--mayhem-option-min')) || 76;
    const gap = parseFloat(css.columnGap) || 8;
    const width = group.clientWidth;
    if (!width) return;
    const columns = String(Math.max(1, Math.min(count, Math.floor((width + gap) / (minimum + gap)))));
    if (group.style.getPropertyValue('--mayhem-option-columns') !== columns) group.style.setProperty('--mayhem-option-columns', columns);
  };
  const resize = new ResizeObserver(entries => entries.forEach(entry => update(entry.target)));
  const options = new MutationObserver(() => groups.forEach(update));
  groups.forEach(group => { update(group); resize.observe(group); options.observe(group, { childList:true, subtree:true, attributes:true, attributeFilter:['hidden'] }); });
  document.addEventListener('mayhem:spec-options-updated', () => groups.forEach(update));
})();
